<template>
  <div class="navigator-bar">
    <div class="navigator-panel">
      <router-link :class="isActive(value.path) === 0 ? 'active' : ''" v-for="(value, index) in routerNav" :key="index"
                   :to="{ name: value.name, query: { currKey: channelType } }">
        {{ value.title }}
      </router-link>
    </div>
  </div>
</template>

<script>
import {routerObject} from '../../router/index'
import {mapGetters} from "vuex";

export default {
  name: 'navigatorBar',
  data() {
    return {
      currPath: '/'
    }
  },

  computed: {
    ...mapGetters([
      'channelType',
      'channelName'
    ]),
    routerNav() {
      return routerObject.filter(value => {
        return value.name && value.meta && value.meta.showNav
      }).map(value => {
        if ('industry' == value.name) {
          if (this.channelType == 1) {
            return {
              path: value.path,
              name: value.name,
              title: this.channelName
            }
          }
        }

        return {
          path: value.path,
          name: value.name,
          title: value.meta ? value.meta.title : ''
        }
      })
    }
  },
  methods: {
    goTo(path) {
      this.currPath = '/' + path
      if (this.$route.path === this.currPath) return false
      if (path === 'industry') {
        this.$router.push({name: path, query: {currKey: this.channelType}})
        return
      }
      this.$router.push({name: path})
    },
    isActive(path) {
      return this.currPath.indexOf(path)
    }
  },
  created() {
    this.currPath = this.$route.path
  },
  watch: {
    $route() {
      this.currPath = this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
$hoverBackground: #801A1B;
.navigator-bar {
  background: $bloodRed;
  width: 100%;
  height: p2r(60px);

  .navigator-panel {
    max-width: p2r(1200px);
    margin: 0 auto;
    display: flex;

    a {
      display: inline-block;
      width: p2r(170px);
      height: p2r(60px);
      line-height: p2r(60px);
      text-align: center;
      color: #ffffff;
      font-size: p2r(18px);
      cursor: pointer;

      &:hover {
        background: $hoverBackground;
      }
    }
  }

  .active {
    background: $hoverBackground;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerComp/navigatorBar.vue